import { useParams } from "react-router-dom";
import NotificationControlView from "./NotificationControlView";
import useNotificationControlModel from "./useNotificationControlModel";
import store from "app/store/store";

export interface UseNotificationControlProps {
  idUser?: number;
}

const NotificationControlPage = () => {
  const { idUser } = useParams<{ idUser?: string }>();

  const model = useNotificationControlModel({
    idUser: idUser ? Number(idUser) : undefined,  
  });
  return <NotificationControlView {...model} />;
};

export default NotificationControlPage;
